import React, { Component } from "react";
import { connect } from "react-redux";
import { Container } from "reactstrap";

import historyAction from "../../redux/history/action";
import nextOfKinAction from "../../redux/nextOfKin/action";
import authAction from "../../redux/auth/action";
import PageHead from "../../component/pageHead/PageHead";
import CustomList from "../../component/CustomList/CustomList";
import {
  isNetworkRequestFailedError,
  parseNextOfKinData,
} from "../../config/helpers";
import api from "../../config/api";
import CustomLoader from "../../component/CustomLoader/CustomLoader";

class NextOfKin extends Component {
  constructor() {
    super();
    this.state = {
      nextToKinObj: "",
      isLoading: false,
    };
  }

  componentDidMount() {
    const { history, setHistory, nextToKinObj } = this.props;

    if (!nextToKinObj) {
      this.fetchDetails();
    }

    setHistory(history);
  }

  fetchDetails = async () => {
    const { user, setAlertMessage, setNextOfKin } = this.props;

    try {
      this.setState({ isLoading: true });
      const data = await api.fetchNextOfKinDetails(
        { pin: user.profile.pin },
        user.token
      );
      const result = parseNextOfKinData(data.data.result);
      setNextOfKin(result);

      this.setState({ nextToKinObj: result, isLoading: false });
    } catch (e) {
      setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e) ? this.fetchDetails : null,
      });
      this.setState({ isLoading: false });
    }
  };

  render() {
    const { isLoading } = this.state;
    const { nextToKinObj } = this.props;

    return (
      <Container>
        <PageHead title="NEXT OF KIN" containerStyles={{ width: "100%" }} />
        {nextToKinObj && <CustomList data={nextToKinObj} />}
        {isLoading && <CustomLoader />}
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  nextToKinObj: state.nextOfKin.nextToKinObj,
});

const mapDispatchToProps = {
  setHistory: historyAction.setHistory,
  setAlertMessage: authAction.setAlertMessage,
  setNextOfKin: nextOfKinAction.setNextOfKin,
};

export default connect(mapStateToProps, mapDispatchToProps)(NextOfKin);
